import { render, staticRenderFns } from "./creationTheory.vue?vue&type=template&id=58cdb644&scoped=true"
import script from "./creationTheory.vue?vue&type=script&lang=js"
export * from "./creationTheory.vue?vue&type=script&lang=js"
import style0 from "./creationTheory.vue?vue&type=style&index=0&id=58cdb644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cdb644",
  null
  
)

export default component.exports